import { Spinner, Typography } from '@ag1/ui';
import { UpgradedFormula } from '@portal/shared/components/UpgradedFormula/UpgradedFormula';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { FlavorLabel } from '../FlavorLabel';
import styles from './ProductDetails.module.scss';

type FlavorInfo = {
  title: string;
  color: string;
};

interface ProductDetailsProps {
  title: string;
  subtitle?: string;
  flavor?: FlavorInfo;
  discountedPriceText: string;
  originalPriceText?: string;
  hasDiscount?: boolean;
  showUpgradedFormula?: boolean;
  showPreferredFlavor?: boolean;
  quantityEditor?: ReactNode;
  isProcessing?: boolean;
  dataTestId?: string;
}

export const ProductDetails = ({
  title,
  subtitle,
  flavor,
  discountedPriceText,
  originalPriceText,
  hasDiscount,
  showUpgradedFormula,
  showPreferredFlavor,
  quantityEditor,
  dataTestId,
  isProcessing
}: ProductDetailsProps) => {
  return (
    <div className={styles.detailsContainer} data-testid={dataTestId}>
      <div className={styles.productInfoSection}>
        {showUpgradedFormula && <UpgradedFormula text="Upgraded Formula" />}
        {showPreferredFlavor && <UpgradedFormula text="Member preferred flavor" />}
        <Typography
          variant="portalText"
          weight="700"
          size="2"
          color="black-new"
          noPadding
          className={styles.title}>
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="portalText"
            size="2"
            color="grey-1-new"
            noPadding
            className={styles.subtitle}>
            {subtitle}
          </Typography>
        )}
        {!!flavor && <FlavorLabel title={flavor.title} color={flavor.color} />}
      </div>
      <div className={styles.rightColumn}>
        <div className={clsx(styles.priceArea, { [styles.hasDiscount]: hasDiscount })}>
          <div className={styles.priceContentWrapper}>
            {isProcessing ? (
              <Spinner withOverlay={false} size={24} />
            ) : (
              <Typography
                variant="portalText"
                size="2"
                color="black-new"
                noPadding
                className={styles.price}>
                {discountedPriceText.toLowerCase() === 'free' && hasDiscount
                  ? discountedPriceText.toUpperCase()
                  : discountedPriceText}
              </Typography>
            )}
          </div>
          {hasDiscount && !isProcessing && originalPriceText && (
            <Typography
              variant="portalCaption"
              size="1"
              color="grey-1-new"
              noPadding
              className={styles.originalPrice}>
              <s>{originalPriceText}</s>
            </Typography>
          )}
        </div>
        {quantityEditor && quantityEditor}
      </div>
    </div>
  );
};
